import { combineReducers, Reducer } from 'redux'
import { FHIR_RESOURCES_RECEIVED } from '../Shared/actions'
import { appendAllUniqueIds, reduceById } from '../Shared/ducks'
import { Questionnaire } from 'fhir-stu3'
import { ById } from '../Shared/ducks/types'

export const allIds: Reducer<string[]> = (state = [], action) => {
  switch (action.type) {
    case FHIR_RESOURCES_RECEIVED:
      return appendAllUniqueIds(state, action.payload.Questionnaire)
    default:
      return state
  }
}

export const byId: Reducer<ById<Questionnaire>> = (state = {}, action) => {
  switch (action.type) {
    case FHIR_RESOURCES_RECEIVED:
      return reduceById(state, action.payload.Questionnaire)
    default:
      return state
  }
}

export default combineReducers({ allIds, byId })
